import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Modal } from 'syngenta-react-components'
import DetailView from '../../../dpe-usco/components/Details/DetailView'
import CompanyUploader from '../../DocUploader/CompanyUploader'
import '../../../scss/config/_variables.scss'
import greenCheck from '../../../assets/icons/circle_check_green.svg'
import close from '../../../assets/icons/close.svg'
import { postCompanyTraining } from '../../../services/apiHelper'

const CancelModal = ({ showCancelModal, setCancelModal }) => {
  let history = useHistory()
  return (
    <Modal
      autoHeight
      show={showCancelModal}
      handleClose={() => setCancelModal(false)}
    >
      <div className='w100% tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40'>
        <div className='bb1-s-lightgray df jcsb'>
          <div className='df ml15 mt15 mb15'>
            <div className='fw600 ml10'>
              Leave scale ticket upload?
            </div>
          </div>
        </div>
        <div className='p25 h80 df aic jcfs'>
          Unsaved company training will not be saved on leaving.
        </div>
        <div className='bt1-s-lightgray df aic jcfe'>
          <div className='mt8 mb8 mr8'>
            <Button customClassName='mr8 miw75 pl1 pr1' text='Close' onClick={() => setCancelModal(false)} />
            <Button customClassName='miw70' type='error' text='Leave upload' onClick={() => history.goBack()} />
          </div>
        </div>
      </div>
    </Modal>
  )
}
const LoadingModal = ({ loading }) => {
  return (
    <Modal
      autoHeight
      show={loading}
    >
      <div className='w100% tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40'>
        <div className='bb1-s-lightgray df jcsb'>
          <div className='df ml15 mt15 mb15'>
            <div className='loader h20 w20' />
          </div>
        </div>
      </div>
    </Modal>
  )
}
const SucessModal = ({ showSucessModal, setShowSucessModal }) => {
  return (
    <Modal
      autoHeight
      show={showSucessModal}
      handleClose={() => setShowSucessModal(false)}
    >
      <div className='w100% tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40'>
        <div className='bb1-s-lightgray df jcsb'>
          <div className='df ml15 mt15 mb15'>
            <img src={greenCheck}
              alt='success icon'>
            </img>
            <div className='ml10'>
              {'training uploaded successfully'}
            </div>
          </div>
          <img className='mr15 curp' onClick={() => setShowSucessModal(false)} src={close}
            alt='close icon'>
          </img>
        </div>
      </div>
    </Modal>
  )
}
export const UploadCompanyTrainingView = () => {
  const [hasUpload, setHasUpload] = useState(false)
  const [hasAllRequiredData, setHasAllRequiredData] = useState(false)
  const [checkGrowerModalVisibility, setCheckGrowerModalVisibility] = useState(false)
  const [showCancelModal, setCancelModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showSucessModal, setShowSucessModal] = useState(false)
  const [parentTableData, setParentTableData] = useState()
  const [currentParentProductionYear, setCurrentParentProductionYear] = useState('')



  const savaData = async () => {
    if (parentTableData) {
      const sumbitData = []
      parentTableData && parentTableData.forEach(data => {
        let obj = {
          training_year: currentParentProductionYear,
          company_sap_id: data['Company SAP ID'].toString() && data['Company SAP ID'].toString().length === 8 ? '00' + data['Company SAP ID'] : data['Company SAP ID'],
          contact_name: data['Contact Name'],
          company_name: data['Company Name'],
          contact_email: data['Contact E-mail'],
          active: 'true'
        }
        sumbitData.push(obj)
      })
      saveHandler({ training_docs: sumbitData })
    }
  }
  const saveHandler = async bulkData => {
    if (bulkData) {
      setLoading(true)
      let response = await postCompanyTraining(bulkData)
      if (response && response.status === 200) {
        setLoading(false)
        setCheckGrowerModalVisibility(false)
        setShowSucessModal(true)
      } else {
        setLoading(false)
      }

    }
  }


  const buttons = (
    <div className='df'>
      <div className='mr10'>
        <Button text='Cancel' clickHandler={() => setCancelModal(true)}></Button>
      </div>
      <div>
        <Button text='Save and Upload' backgroundColor={hasUpload ? '#238661' : '#8FC0AE'} textColor={'#FFFFFF'} disabled={!hasUpload || !hasAllRequiredData} clickHandler={savaData}></Button>
      </div>
    </div>)
  return (loading ? <LoadingModal loading={loading} /> :
    <>
      <CancelModal showCancelModal={showCancelModal} setCancelModal={setCancelModal} />
      {/* <button
        className='df aic jcsb posf l20'
        style={{
          background: 'none',
          color: 'inherit',
          border: 'none',
          padding: 0,
          font: 'inherit',
          cursor: 'pointer',
          outline: 'inherit'
        }}
        onClick={() => setCancelModal(true)}>
        <img src={leftArrow} alt='return arrow' className='curp mr10' />
        <span className='fz17 c-neutral-500 fs'>Back</span>
      </button> */}

      <DetailView button={buttons} title={'Upload Stewardship Training'} disableBack={true}>
        <>
          <SucessModal showSucessModal={showSucessModal} setShowSucessModal={setShowSucessModal} />
          <CompanyUploader setHasUpload={setHasUpload} setHasAllRequiredData={setHasAllRequiredData} checkGrowerModalVisibility={checkGrowerModalVisibility} toggleCheckGrowerModalVisibility={setCheckGrowerModalVisibility} setLoading={setLoading} setShowSucessModal={setShowSucessModal} setParentTableData={setParentTableData} setCurrentParentProductionYear={setCurrentParentProductionYear} />
        </>
      </DetailView>
    </>
  )
}

export default UploadCompanyTrainingView
